var React = require('react');
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';

var Settings = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  getInitialState: function() {
    return {};
  },
  handleChangeData: function(field, e) {
    var update = {};
    update[field] = e.target.value;
    this.setState(update);
  },
  submit: function() {
    var _this = this;
    var oldPassword = _this.state.currentPassword;
    var newPassword = _this.state.newPassword;
    var confirmPassword = _this.state.confirmPassword;
    if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    if (newPassword !== confirmPassword) return alert('New password not match');
    _this.setState({
      isLoading: true
    })
    Auth.changePassword({
      "oldPassword": oldPassword,
      "newPassword": newPassword
    }, function(err, res) {
      _this.setState({
        isLoading: false
      })
      if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
      if (err) return alert('Error occurred. Please try again later');
      alert('Change password success');
    })
  },
  render: function() {
    var _this = this;
    return (
      <div>
        <h2> Change Password </h2>
        <div className="row">
          <div className="col col-md-2">
            <label> Current Password</label>
          </div>
          <div className="col col-md-10">
            <input type="password" className="form-control mark-input" onChange={_this.handleChangeData.bind(_this, 'currentPassword')} value={_this.state.currentPassword}/>
          </div>
        </div>
        <div className="row">
          <div className="col col-md-2">
            <label> New Password </label>
          </div>
          <div className="col col-md-10">
            <input type="password" className="form-control mark-input" onChange={_this.handleChangeData.bind(_this, 'newPassword')} value={_this.state.newPassword}/>
          </div>
        </div>
        <div className="row">
          <div className="col col-md-2">
            <label> Confirm New Password</label>
          </div>
          <div className="col col-md-10">
            <input type="password" className="form-control mark-input" onChange={_this.handleChangeData.bind(_this, 'confirmPassword')} value={_this.state.confirmPassword}/>
          </div>
        </div>
        {
          _this.state.isLoading && <CircularProgress className="loading"/>
        }
        {
          !_this.state.isLoading &&
            <RaisedButton
              label="Submit"
              secondary={true}
              onClick={_this.submit}
            />
        }   
      </div>
    );
  }

});

module.exports = Settings;



/** WEBPACK FOOTER **
 ** ./src/components/Settings/settings.js
 **/